import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, VehicleService, VehicleServiceApi } from '../../../../shared/sdk';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-vehicle-service-details-tab-fleet-manager-comments',
  templateUrl: './vehicle-service-details-tab-fleet-manager-comments.component.html',
  styleUrls: ['./vehicle-service-details-tab-fleet-manager-comments.component.scss'],
  providers: [],
})
export class VehicleDetailsTabfleetManagerCommentsComponent extends ABaseComponent {
  _vehicleService: VehicleService;

  @Input()
  set vehicleService(v: VehicleService) {
    this._vehicleService = v;
    this.changeHandle();
  }
  get vehicleService() {
    return this._vehicleService;
  }

  dso: DataSourceOptions;

  constructor(
    protected logger: LoggerService,
    protected ui: UiService,
    protected dss: DataSourceService,
    protected dialog: MatDialog,
  ) {
    super(logger);
  }

  changeHandle() {}

  async onCommentInserting(event: any): Promise<void> {
    try {
      event.data.id = event.data.__KEY__;
      event.data.createdAt = new Date();
      event.data.updatedAt = new Date();

      let { fleetManagerComments } = this.vehicleService;
      fleetManagerComments = [{ ...event.data, __KEY__: undefined }, ...this.vehicleService.fleetManagerComments];
      this.vehicleService.fleetManagerComments = fleetManagerComments; // Update the local state with predicted data

      // Call the API to add the new fleetManagerComments
      const updatedVehicleService = await this.dss
        .getApi<VehicleServiceApi>(VehicleService)
        .mySaveWithRelated(this.vehicleService.id, { fleetManagerComments })
        .toPromise();

      // Update the local state with the response
      this.vehicleService.fleetManagerComments = updatedVehicleService.fleetManagerComments;
    } catch (error) {
      notify('Error inserting comment', 'error', 3000);
      console.error('Error inserting comment:', error);
      event.cancel = true;
    }
  }

  async onCommentUpdating(event: any): Promise<void> {
    try {
      const { fleetManagerComments } = this.vehicleService;
      const index = fleetManagerComments.findIndex((inv: any) => inv.id === event.key.id);
      if (index !== -1) {
        fleetManagerComments[index] = { ...fleetManagerComments[index], ...event.newData, updatedAt: new Date() };
        const { fleetManagerComments: updated } = await this.dss
          .getApi<VehicleServiceApi>(VehicleService)
          .mySaveWithRelated(this.vehicleService.id, { fleetManagerComments })
          .toPromise();
        this.vehicleService.fleetManagerComments = updated;
      }
    } catch (error) {
      notify('Error updating comment', 'error', 3000);
      console.error('Error updating comment:', error);
      event.cancel = true;
    }
  }

  async onCommentRemoving(event: any): Promise<void> {
    const { fleetManagerComments } = this.vehicleService;
    const index = fleetManagerComments.findIndex((inv: any) => inv.id === event.key.id);
    if (index !== -1) {
      fleetManagerComments.splice(index, 1);
      const { fleetManagerComments: updated } = await this.dss
        .getApi<VehicleServiceApi>(VehicleService)
        .mySaveWithRelated(this.vehicleService.id, { fleetManagerComments })
        .toPromise();
      this.vehicleService.fleetManagerComments = updated;
    }
  }
}
